export class ResponseType {
    constructor() {
        this.ok = true;
        this.type = 0;
        this.data = null;
    }
    ok: boolean;
    data: any;
    type: number;
}